import './css/index.css';
import 'components/breadcrumbs';
import 'components/footer';
import 'components/notification';
import 'components/local-navigation';
import 'components/card-content-image';
import 'components/email-notification';
import 'components/data-download-table';
import 'components/data-viz-hero';
import 'components/related-content-tileset';
import 'components/related-content-tileset-with-resources';
import 'components/base-side-by-side';
import 'components/text-with-background-image-with-contact';
import 'components/life-data-viz';
import 'components/suggested-citation';
import 'components/release-calendar-tileset';
import 'components/link-grid-with-filters';
import DataPeriodicReleaseArchiveFilter from 'components/data-periodic-release-archive-filter';

import Mediator from 'js/mediator';
import Navigation from 'components/navigation';

Mediator.create( {
    componentClasses: [
        Navigation,
        DataPeriodicReleaseArchiveFilter,
        {
            name: 'life-data-viz',
            label: 'LIFE DV',
            module: () => import(
                'components/life-data-viz',
            ),
        },
    ],
} );
